module.exports = __webpack_public_path__ + "static/train-stops-43f297c954824c9e0f919a3c9ed75f99.png";